// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Breadcrumbs = require("../common/Components/Breadcrumbs.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var ReactRender = require("../../reason/utils/ReactRender.bs.js");
var UserSession = require("../../reason/common/UserSession/UserSession.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var IsNewQueryParam = require("./IsNewQueryParam.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
var MarketingProfileMemberPhotoForm = require("./MarketingProfileMemberPhotoForm.bs.js");
var EditMarketingProfileMemberInfoForm = require("./EditMarketingProfileMemberInfoForm.bs.js");
var EditMarketingProfileMemberQuery_graphql = require("../../__generated__/EditMarketingProfileMemberQuery_graphql.bs.js");
var EditMarketingProfileMemberSocialAccountsForm = require("./EditMarketingProfileMemberSocialAccountsForm.bs.js");
var EditMarketingProfileMember_page_marketingProfileMember_graphql = require("../../__generated__/EditMarketingProfileMember_page_marketingProfileMember_graphql.bs.js");
var EditMarketingProfileMember_header_marketingProfileMember_graphql = require("../../__generated__/EditMarketingProfileMember_header_marketingProfileMember_graphql.bs.js");

var convertFragment = EditMarketingProfileMember_header_marketingProfileMember_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, EditMarketingProfileMember_header_marketingProfileMember_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(EditMarketingProfileMember_header_marketingProfileMember_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, EditMarketingProfileMember_header_marketingProfileMember_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(EditMarketingProfileMember_header_marketingProfileMember_graphql.node, convertFragment, fRef);
}

var Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function EditMarketingProfileMember$Header(props) {
  var member = use(props.member);
  var match = IsNewQueryParam.use();
  var breadcrumbs = [
    {
      name: "Team Marketing Profile",
      href: "/account/team_marketing_profile"
    },
    {
      name: "Members",
      href: "/account/team_marketing_profile/members?is_new=" + (
        match[0] ? "1" : "0"
      )
    },
    {
      name: member.displayName,
      href: "/account/team_marketing_profile/members/" + member.id + "/edit"
    }
  ];
  var name = Core__Option.getOr(member.firstName, member.displayName);
  return JsxRuntime.jsxs("header", {
              children: [
                JsxRuntime.jsx(Breadcrumbs.make, {
                      pages: breadcrumbs
                    }),
                JsxRuntime.jsx("h2", {
                      children: "Edit " + name + "'s profile",
                      className: "text-zinc-800 text-3xl font-medium"
                    })
              ],
              className: "space-y-3 border-b pb-2"
            });
}

var Header = {
  Fragment: Fragment,
  make: EditMarketingProfileMember$Header
};

var convertFragment$1 = EditMarketingProfileMember_page_marketingProfileMember_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, EditMarketingProfileMember_page_marketingProfileMember_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(EditMarketingProfileMember_page_marketingProfileMember_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, EditMarketingProfileMember_page_marketingProfileMember_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(EditMarketingProfileMember_page_marketingProfileMember_graphql.node, convertFragment$1, fRef);
}

var Fragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function EditMarketingProfileMember$Page(props) {
  var member = use$1(props.member);
  var hasFullProfile = UserSession.useHasPlanFeature("FULL_AGENT_PAGE");
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx(EditMarketingProfileMember$Header, {
                            member: member.fragmentRefs
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("h3", {
                                            children: "Member information",
                                            className: "text-lg font-semibold leading-7 text-gray-900 sm:gap-4 sm:py-6"
                                          }),
                                      JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx(EditMarketingProfileMemberInfoForm.make, {
                                                  member: member.fragmentRefs
                                                }),
                                            className: "pt-4 sm:pt-0"
                                          })
                                    ],
                                    className: "pb-12 space-y-4 sm:space-y-0 divide-y divide-zinc-200 sm:pb-0"
                                  }),
                              (function (__x) {
                                    return ReactRender.ifTrue(JsxRuntime.jsxs(JsxRuntime.Fragment, {
                                                    children: [
                                                      JsxRuntime.jsxs("div", {
                                                            children: [
                                                              JsxRuntime.jsx("h3", {
                                                                    children: "Profile picture",
                                                                    className: "text-lg font-semibold leading-7 text-gray-900 sm:gap-4 sm:py-6"
                                                                  }),
                                                              JsxRuntime.jsx("div", {
                                                                    children: JsxRuntime.jsx(MarketingProfileMemberPhotoForm.make, {
                                                                          member: member.fragmentRefs
                                                                        }),
                                                                    className: "pt-4 sm:pt-0"
                                                                  })
                                                            ],
                                                            className: "pb-12 space-y-4 sm:space-y-0 divide-y divide-zinc-200 sm:pb-0"
                                                          }),
                                                      JsxRuntime.jsxs("div", {
                                                            children: [
                                                              JsxRuntime.jsx("h3", {
                                                                    children: "Social Accounts",
                                                                    className: "text-lg font-semibold leading-7 text-gray-900 sm:gap-4 sm:py-6"
                                                                  }),
                                                              JsxRuntime.jsx("div", {
                                                                    children: JsxRuntime.jsx(EditMarketingProfileMemberSocialAccountsForm.make, {
                                                                          member: member.fragmentRefs
                                                                        }),
                                                                    className: "pt-4 sm:pt-0"
                                                                  })
                                                            ],
                                                            className: "pb-12 space-y-4 sm:space-y-0 divide-y divide-zinc-200 sm:pb-0"
                                                          })
                                                    ]
                                                  }), __x);
                                  })(hasFullProfile)
                            ],
                            className: "space-y-6"
                          })
                    ],
                    className: "space-y-8 sm:space-y-0"
                  }),
              className: "bg-white p-6 shadow-sm rounded space-y-8"
            });
}

var Page = {
  Fragment: Fragment$1,
  make: EditMarketingProfileMember$Page
};

var convertVariables = EditMarketingProfileMemberQuery_graphql.Internal.convertVariables;

var convertResponse = EditMarketingProfileMemberQuery_graphql.Internal.convertResponse;

var convertWrapRawResponse = EditMarketingProfileMemberQuery_graphql.Internal.convertWrapRawResponse;

var use$2 = RescriptRelay_Query.useQuery(convertVariables, EditMarketingProfileMemberQuery_graphql.node, convertResponse);

var useLoader = RescriptRelay_Query.useLoader(convertVariables, EditMarketingProfileMemberQuery_graphql.node, (function (prim) {
        return prim;
      }));

var usePreloaded = RescriptRelay_Query.usePreloaded(EditMarketingProfileMemberQuery_graphql.node, convertResponse, (function (prim) {
        return prim;
      }));

var $$fetch = RescriptRelay_Query.$$fetch(EditMarketingProfileMemberQuery_graphql.node, convertResponse, convertVariables);

var fetchPromised = RescriptRelay_Query.fetchPromised(EditMarketingProfileMemberQuery_graphql.node, convertResponse, convertVariables);

var retain = RescriptRelay_Query.retain(EditMarketingProfileMemberQuery_graphql.node, convertVariables);

var Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use$2,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  $$fetch: $$fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function EditMarketingProfileMember(props) {
  var match = use$2({
        memberId: props.memberId
      }, undefined, undefined, undefined);
  var result = match.marketingProfileMember;
  if (result.__typename === "MarketingProfileMember") {
    return JsxRuntime.jsx(EditMarketingProfileMember$Page, {
                member: result.fragmentRefs
              });
  } else {
    return UnselectedUnionMemberError.raise("Unselected union member: " + result._0);
  }
}

var make = EditMarketingProfileMember;

exports.Header = Header;
exports.Page = Page;
exports.Query = Query;
exports.make = make;
/* use Not a pure module */
